var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaper(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.738 2.762H8.085A3.82 3.82 0 004.25 6.49v10.713a3.828 3.828 0 003.742 3.91c.03 0 .06.002.092 0h7.989a3.887 3.887 0 003.729-3.91V8.038l-5.065-5.276z",
    stroke: "#ED1B2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.476 2.75v2.909a2.574 2.574 0 002.568 2.575h2.755M14.289 15.358h-5.4M12.244 11.606H8.888",
    stroke: "#ED1B2E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgIconPaper;